@if (isBlockedUIActive()) {
<div class="blocked-overlay">
  <ng-lottie width="400px" [options]="options" />
</div>
}
<app-confirm-popup> </app-confirm-popup>
<p-toast />
<!-- if mobile screen, show toast at bottom center -->
@if (isMobile()) {
<p-toast key="connectivity" position="bottom-center" />
} @else {
<p-toast key="connectivity" position="top-center" />
}
<router-outlet />
